var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.currentTheme,attrs:{"id":"app"}},[_c('router-view'),(!this.session || !this.session.user || this.session.user.groups.length === 0)?_c('AccesibilityBar'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }